var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder",class:{ 'placeholder-message-visible': _vm.displayMessage }},[_vm._v(" The request could not be processed."),_c('br'),_vm._v(" Please try again or refresh the page (F5). ")])}
var staticRenderFns = []

export { render, staticRenderFns }